import { Component, OnInit, Input } from '@angular/core';
import { FormElementAffiliationCode } from '../shared/model/affiliation-code/form-element-affiliation-code.model';

@Component({
  selector: 'wl-form-builder-affiliation-checklist-display-element',
  templateUrl: 'form-builder-affiliation-checklist-display-element.component.html',
    standalone: false
})
export class FormBuilderAffiliationChecklistDisplayElementComponent {
  @Input('affiliationSettings') affiliationSettings: FormElementAffiliationCode;

  public constructor() {
    this.affiliationSettings = new FormElementAffiliationCode();
  }

  ngOnInit(): void {}
}
